import Notification from './Notification';
import PreviewManager from '../managers/preview/PreviewManager';
import HttpClient from '../services/HttpClient';
import {Html5Qrcode} from "html5-qrcode"
import configs from '../configs';

const IMAGE_SERVICE = configs.API_DOMAIN_NAME;

// export function scannabilityCheck(base64Image) {
//   return new Promise((resolve, reject) => {

//     const image = document.getElementById('qrDesignPreview');

//     // Set the src attribute of the img element to the base64 image data
//     image.src = base64Image;

//     image.onload = function () {
//       const canvas = document.createElement('canvas');
//       document.body.appendChild(canvas)
//       var context = canvas.getContext('2d');

//       canvas.width = image.width;
//       canvas.height = image.height;
//       context.drawImage(image, 0, 0, canvas.width, canvas.height);

//       const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
//       const code = jsQR(imageData.data, canvas.width, canvas.height);
//       if (code) {
//         document.body.removeChild(canvas);
//         resolve(true);
//       } else {
//         document.body.removeChild(canvas);
//         resolve(false);
//       }

//     }

//   })
// }

export async function generateImageCheckscannability(config, defaultImageConfig, v1ImageConfig, httpClient = null) {
  const designerHttpClient = httpClient || new HttpClient(IMAGE_SERVICE);
  const previewManager = new PreviewManager(designerHttpClient, defaultImageConfig, v1ImageConfig);
  const configForScan = {
    name:"",
    qrImageFormData:JSON.stringify(config),
    shortUrl:""
  }
  const resp = await previewManager.create(configForScan)
  return resp ? await scannabilityCheck(resp.base64Image) : false;
}

export function scannabilityCheck(base64Image) {
  return new Promise((resolve, reject) => {
    const readerElement = document.getElementById("reader");
    if (!readerElement) {
      console.warn("Reader element not found, skipping scannability check");
      resolve(false);
      return;
    }
    let removeBase64Prefix = base64Image;
    if (base64Image.startsWith('data:image')) {
      removeBase64Prefix = base64Image.split(',')[1];
    }
    const html5QrCode = new Html5Qrcode(/* element id */ "reader");
    let scanabilityCheck = false;
    const imageFile = base64ToFile(removeBase64Prefix, 'image.png', 'image/png')
    // check if the file is a QR code
    html5QrCode.scanFile(imageFile, true)
    .then(decodedText => {
      // success, it is a QR code and it is readable
      scanabilityCheck = true;
      resolve(true)
    })
    .catch(err => {
      // failure, handle it.
      console.log(`Error scanning file. Reason: ${err}`)
      scanabilityCheck = false;
      resolve(false)
    });
  })
}

function base64ToFile(base64String, fileName, fileType) {
  // Convert the base64 string to binary data
  const binaryData = atob(base64String);

  // Create a Uint8Array to hold the binary data
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i);
  }

  // Create a Blob from the binary data
  const blob = new Blob([uint8Array], { type: fileType });

  // Create a File object from the Blob
  const imageFile = new File([blob], fileName, { type: fileType });

  return imageFile;
}
